import styled from 'styled-components';

import { StyledCategoryTag } from '../';

import { BORDER, WHITE, GREY, DARK_GREY, LIGHT_BLUE, SIZE, ASPHALT_GREY, WHITESMOKE, SUPER_LIGHT_GRAY } from '../../const';

export const StyledBlogpostTitle = styled.div`
    max-width: 1141px;
    margin:  ${props =>  props.banner ? '40px auto 38px': '50px auto 0'}; 
    ${props => props.banner ? `background: linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${props.bg});` : ''}
    height: ${props => props.banner ? '420px' : 'auto'};
    padding: ${props => props.banner ? '30px' : '0'};
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    background-size: cover;
    background-position: center;


    @media ${SIZE.laptopL} { 
        ${props => props.banner ? '' : 'padding: 0 20px;'}
    }

    @media (max-width: 1200px) {
        margin-left: 20px;
        margin-right: 20px;
    }

    .title {
        font-size: 21px;
        line-height: 29px;
        font-weight: 700;
        margin-top: 10px;
        color:  ${props => props.banner ? WHITE : DARK_GREY};
        width: ${props => props.banner ? '100%' : '65%'};
    }

    .categories {
        display: flex;
        > * {
            margin: 0;

            &:not(:last-child) {
                margin-right: 10px;
            }
        }
    }

    img {
        width: 256px;
        height: 70px;
    }

    @media ${SIZE.tablet} {
        padding:  ${props => props.banner ? '15px' : '0 15px'};
        height: ${props => props.banner ? '403px' : 'auto'};
        margin:  ${props => props.banner ? '15px 15px 12px' : '40px 0 0 0'};

        .title {
            font-size: 21px;
            line-height: initial;
            width: 100%;
        }
    }
`;

export const StyledImgPreview = styled.div`
    width: 160px;
    height: 100%;
    margin-right: 14px;
    background: url(${props=>props.bg});
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
`;

export const StyledBlogpostContent = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 74px;

    @media ${SIZE.tablet} {
        margin-bottom: 34px;
    }

    .credits {
        display: flex;
        width: 100%;
        justify-content: space-between;
        padding-top: 20px;
        padding-bottom: 18.5px;
        border-bottom: ${BORDER};

        @media ${SIZE.tablet} {
            padding: 10px 0;
        }
    }

    .author {
        color: ${GREY};
        font-size: 16px;
        line-height: 35px;
    }

    .content {
        width: 100%;
        padding: 24.5px 0;
        font-size: 16px;
        line-height: 1.714285714;
        color: ${DARK_GREY};
        word-break: break-word;
                
        > * {
            margin-bottom: 24px;
        }

        h1 {
            font-weight: bold;
            font-size: 28px;
        }

        h2 {
            font-size: 21px;
            margin-block-start: 24px;
            margin-block-end: 24px;
        }

        .image {
            max-width: 100%;
            padding 15px;

            &-style-side {
                float:right;
                max-width: 35%;

                @media ${SIZE.tablet} {
                    width: 100%;
                    max-width: initial;
                }
            }
        }

        img {
            height: auto;
            max-width: 100%;
        }

        ul {
            list-style: disc outside;
        }

        ol {
            list-style: decimal outside;
        }

        ol, ul {
            margin-bottom: 24px;

            li {
                margin: 0 0 0 36px;
            }
        }

        p {
            margin: 0 0 24px;
        }

        .embed-responsive {
            width: 100%;
            position: relative;
            
            &:after {
                content: '';
                display: block;
                padding-top: 56.25%;  
            }

            iframe {
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
            }

            &-item {
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                width: 100%;
                height: 100%;
            }
        }

        .videoWrapper {
            position: relative;
            padding-bottom: 56.25%;
            height: 0;

            iframe {
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
            }
        }

        iframe {
            width: 100%;
        }

        table {
            td, th {
                padding: 6px 10px;
                font-weight: normal;
                text-align: left;
            }

            tr {
                border-bottom: 1px solid ${SUPER_LIGHT_GRAY};
            }
        }

        .table-wrapper {
            overflow-x: auto;
            padding: 1px;

            table {
                border-collapse: collapse;
                border-spacing: 0;
                color: #757575;
                width: 100%;
                border-radius: 10px;
                border-style: hidden;
                min-width: 720px;
                box-shadow: 0 0 0 1px ${ASPHALT_GREY};
                position: relative;

                tr {
                    border-bottom: none;
                }

                tr:not(:first-child):not(:last-child) {
                    border-bottom: 1px solid ${ASPHALT_GREY};
                    border-top: 1px solid ${ASPHALT_GREY};
                }

                td, th {
                    &:not(:last-child) {
                        border-right: 1px solid ${ASPHALT_GREY};
                    }
                    &:not(:first-child) {
                        border-left: 1px solid ${ASPHALT_GREY};
                    }
                }

                tr:nth-child(2n) {
                    background-color: ${WHITESMOKE};
                }

                &:after {
                    content: "";
                    display: block;
                    position: absolute;
                    right: -1px;
                    width: 1px;
                    height: 1px;
                }
            }
        }
    }

    .lastLine {
        width: 100%;
        font-size: 16px;
        line-height: 22px;
        display: flex;
        align-items: center;
        color: ${GREY};
        margin-bottom: 0;


        span {
            margin-right: 19px;
        }
    }

    ${StyledCategoryTag} {
        margin-bottom: 0;
    }

    @media ${SIZE.tablet} {
        .author {
            font-size: 12px;
            line-height: 16px;
        }

        .lastLine {
            flex-wrap: wrap;
        }
    }
 `;

export const StyledBlogpostLinked = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 47px;

    .item {
        width: 48%;
        display: flex;
        font-weight: bold;
        font-size: 16px;
        line-height: 130%;

        &-right {
            text-align: right;
            justify-content: flex-end;

            ${StyledImgPreview} {
                margin-left: 14px;            
            }
        }

        .title {
            margin-bottom: 10px;
            color: ${LIGHT_BLUE};
        }

        .subtitle {
            opacity: 0.3;
            color: ${DARK_GREY};
        }
    }

    @media ${SIZE.tablet} {
        flex-wrap: wrap;

        .item {
            width: 100%;
            margin-bottom: 21px;

            ${StyledImgPreview} {
                width: 110px;
                height: 72px;
            }

            &-right {
                text-align: left;
                justify-content: flex-end;
                flex-direction: row-reverse;
    
                ${StyledImgPreview} {
                    margin-left: 0;
                    margin-right: 14px;            
                }
            }
        }
    }
`;
